module.exports = __webpack_public_path__ + "img/sale-badge-5.5f7d6660.png";